import React from 'react'

export const ProjectTemplateContext = React.createContext({})
